import React from 'react';

import { importWithChunkReload } from './chunkLoadError';

type ComponentModule = Record<string, React.ComponentType<any> | any>;
/** 针对与具名导出的懒加载 */
export function lazyNamedImport<T extends ComponentModule>(importer: () => Promise<T>, exportName: keyof T) {
  return React.lazy(async () => {
    const module = await importWithChunkReload(importer);
    const component = module[exportName];
    if (!component) {
      throw new Error(`Component ${String(exportName)} not found in module`);
    }
    return { default: component as React.ComponentType<any> };
  });
}

/**
 * loadable 实现同样是一样需要传入 importer, 和 moduleName
 * 可自定义 loadable 需要传入一个 fallback 组件
 * 考虑到目前的场景懒加载的回显没有组件级别的细粒度控制, 目前先用原生的 React.lazy
 */

// import loadable from '@loadable/component';
// import React from 'react';

// interface ComponentModule {
//   [key: string]: React.ComponentType<any> | any;
// }

// /**
//  * 针对具名导出的组件使用 @loadable/component 实现懒加载，带有类型提示
//  */
// export function lazyNamedImport<T extends ComponentModule, K extends keyof T>(
//   importer: () => Promise<T>,
//   exportName: K,
//   fallback: React.ReactNode = <LoadingComponent />
// ) {
//   return loadable(
//     async () => {
//       const module = await importer();
//       const component = module[exportName];
//       if (!component) {
//         throw new Error(`Component ${String(exportName)} not found in module`);
//       }
//       return { default: component as React.ComponentType<any> };
//     },
//     { fallback }
//   );
// }

// function LoadingComponent() {
//   return (
//     <div
//       className="fade-animation"
//       style={{
//         width: '100%',
//         height: '100vh',
//         display: 'flex',
//         justifyContent: 'center',
//         paddingTop: '300px',
//       }}
//     >
//       <Spin />
//     </div>
//   );
// }
